(function (angular) {

    'use strict';

    angular.module('app.activation', []);
})(angular);